module.exports =
  '_CONTACT':
    'TITLE': 'Contact'
    'SUBJECT': "Subject"
    'YOUR_NAME': 'Your Name'
    'EMAIL_ADDRESS': 'Email Address'
    'BODY': 'Body'
    'SUBJECT_DEFAULT_TEXT': "-- Please choose a subject --"
    'INQUIRY_SUCCESS': 'Your inquiry email has been sent successfully. User support will reply by email.'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/contact/i18n/en.coffee